import {
  Block,
  FlexGrid,
  FlexGridItem,
  Handshake,
  MatsCircle,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { networkUtils } from "#/shared/utils"

export default function MarketMatsnetFooter() {
  const [css, theme] = useStyletron()

  return (
    <FlexGrid
      flexGridColumnCount={2}
      flexGridColumnGap={theme.sizing.scale800}
      marginTop={theme.sizing.scale1000}
    >
      <FlexGridItem
        overrides={{ Block: { style: () => ({ flexGrow: 0, width: "auto" }) } }}
      >
        <Block
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale300,
          })}
        >
          <MatsCircle size={16} />
          <ParagraphSmall color={theme.colors.contentSecondary}>
            {networkUtils.getMezoNetworkLabel()}
          </ParagraphSmall>
        </Block>
      </FlexGridItem>
      <FlexGridItem
        overrides={{ Block: { style: () => ({ flexGrow: 0, width: "auto" }) } }}
      >
        <Block
          className={css({
            display: "flex",
            alignItems: "center",
            gap: theme.sizing.scale300,
          })}
        >
          <Handshake size={16} color={theme.colors.contentSecondary} />
          <ParagraphSmall color={theme.colors.contentSecondary}>
            This isn&apos;t real money.
          </ParagraphSmall>
        </Block>
      </FlexGridItem>
    </FlexGrid>
  )
}
